import { ValColumnEnum } from '@shared-app/lib/types';
import moment from 'moment';
export const extractDate = (arr) => {
    const dataSet = new Set(arr.map(item => moment(item[ValColumnEnum.date]).format('YYYY')));
    const uniqueData = Array.from(dataSet);
    return uniqueData;
};
